import React from 'react';

import CustomTd from '../shared/table/CustomTd';
import formatter from '../../utilities/formatter';

const MonthlyAdvertisingItem = ({ item }) => {
    return (
        <tr>
            <CustomTd>
                {item.leadSource}
            </CustomTd>
            <CustomTd>
                {item.subLeadSource}
            </CustomTd>
            <CustomTd>
                {item.leadsReceived}
            </CustomTd>
            <CustomTd>
                {item.appointmentsScheduled}
            </CustomTd>
            <CustomTd>
                {item.installedJobs}
            </CustomTd>
            <CustomTd>
                {formatter.percent(item.appointmentConversion)}
            </CustomTd>
            <CustomTd>
                {formatter.currency(item.amountSpent)}
            </CustomTd>
            <CustomTd>
                {formatter.currency(item.costPerLead)}
            </CustomTd>
            <CustomTd>
                {formatter.percent(item.closingRate)}
            </CustomTd>
            <CustomTd>
                {formatter.currency(item.installedSales)}
            </CustomTd>
            <CustomTd>
                {formatter.currency(item.averageSale)}
            </CustomTd>
            <CustomTd>
                {formatter.currency(item.revenuePerLead)}
            </CustomTd>
            <CustomTd colSpan={2}>
                {formatter.percent(item.investmentReturn)}
            </CustomTd>
        </tr>
    );
}

export default MonthlyAdvertisingItem;